export function setQuotation(params) {
    return {
        ...params,
        type: 'setQuotation',
    }
}
